import React from 'react';
import { connect } from 'react-redux';
import { editProductConfiguration } from '../../../ProductCustomizer/productCustomizerActions';
import {
  removeProductFromCart,
  decrementProduct,
  incrementProduct,
  toggleProductIsFavourited,
} from '../../../Cart/cartActions';
import ProductEditAndQuantity from './ProductEditAndQuantity';
import { editPreviousProductConfiguration } from '../../../ProductCustomizer/productCustomizerActions';

const ProductEditAndQuantityContainer = ({
  productInCart,
  removeProductFromCart,
  decrementProduct,
  incrementProduct,
  editProductConfiguration,
  toggleProductIsFavourited,
  isForPreview,
  isAuthenticated,
  editPreviousProductConfiguration,
}) => {
  const { productIndexInCart, flatProduct, favouriteId } = productInCart;

  const handleEditProductConfiguration = () => {
    const modifiedProductInCart = { ...productInCart };
    const flatedProduct = { ...productInCart.flatProduct };
    if (productInCart.isFromReorderButton) {
      flatedProduct.price = flatedProduct.price / flatedProduct.quantity;
      modifiedProductInCart.flatProduct = flatedProduct;
      modifiedProductInCart.isEditing = true;
      modifiedProductInCart.isFromReorderButton = false;
      editProductConfiguration(modifiedProductInCart);
    } else {
      editProductConfiguration(productInCart);
    }
  };

  const handleDecrementProduct = () => {
    if (flatProduct.quantity <= 1) {
      removeProductFromCart(productIndexInCart);
    } else {
      decrementProduct(productIndexInCart);
    }
  };

  const handleToggleProductIsFavourited = (favouriteId) =>
    toggleProductIsFavourited(productIndexInCart, favouriteId);

  const handleIncrementProduct = () => incrementProduct(productIndexInCart);
  const handleRemoveProductFromCart = () => {
    removeProductFromCart(productIndexInCart);
  };

  return (
    <ProductEditAndQuantity
      isAuthenticated={isAuthenticated}
      isForPreview={isForPreview}
      quantity={flatProduct.quantity}
      handleToggleProductIsFavourited={handleToggleProductIsFavourited}
      flatProduct={flatProduct}
      favouriteId={favouriteId}
      handleDecrementProduct={handleDecrementProduct}
      handleIncrementProduct={handleIncrementProduct}
      handleEditProductConfiguration={handleEditProductConfiguration}
      handleRemoveProductFromCart={handleRemoveProductFromCart}
    />
  );
};

const mapStateToProps = (state) => ({
  isForPreview: state.cartReducer.isForPreview,
  isAuthenticated: state.authReducer.isAuthenticated,
});

const actions = {
  editProductConfiguration,
  removeProductFromCart,
  decrementProduct,
  incrementProduct,
  toggleProductIsFavourited,
  editPreviousProductConfiguration,
};

export default connect(
  mapStateToProps,
  actions
)(ProductEditAndQuantityContainer);
